import { useTimePilotT } from "@/i18n/useTimePilotT";
import * as React from 'react';

const Dates = React.memo((props: { data: { displayDate: string } }) => {
  const t = useTimePilotT();
  return (
    <div aria-label={t("viewers.id2")} className="flex justify-right">
      {props.data.displayDate}
    </div>
  );
});

Dates.displayName = 'Dates';

export default Dates;
